import axios from "axios"

import { Toast } from 'vant';

// import i18n from "@/locales"

const ROOT_PATH = ""
// const ROOT_PATH = "https://pay.weiyiltd.xyz"
// const ROOT_PATH = "https://twcredit.viennareviews.xyz"
// const ROOT_PATH = "https://vnqr.ngwepay.com"

const http = axios.create({
  baseURL: ROOT_PATH,
  timeout: 300000
})
const SUCCESS_CODE = "200"

http.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8"
http.defaults.headers.delete["Content-Type"] = "application/json;charset=UTF-8"
http.defaults.headers.put["Content-Type"] = "application/json;charset=UTF-8"
http.defaults.transformRequest = [
  function(data) {
    if (Object.prototype.toString.call(data) === "[object FormData]") {
      return data
    } else {
      return JSON.stringify(data)
    }
  }
]

http.interceptors.request.use(
  config => {
    if (!config.noFormatUndefined && config.params) {
      Object.keys(config.params).forEach(key => {
        if (config.params[key] === "") {
          config.params[key] = undefined
        }
      })
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    const data = response.data
    if (response.request.responseType === "blob") {
      return Promise.resolve(response)
    }
    if (data.code !== SUCCESS_CODE) {
      Toast(data.msg);
      // return Promise.reject(data)
      return Promise.resolve(data)
    } else {
      return Promise.resolve(data)
    }
  },
  error => {
    const errorRes = error.response
    if (errorRes) {
      switch (errorRes.status) {
        case 401:
          console.error("登录已过期，请重新登录")
          break
        case 404:
          console.error("请求不存在")
          break
        default:
          console.error(errorRes.data.msg)
      }
    } else {
      if (error.message.includes("timeout")) {
        console.error("请求超时，请检查网络是否正常")
      } else {
        console.error("请求失败，请检查网络是否已连接")
      }
    }
    return Promise.reject(error)
  }
)

export default http